import { useHistory } from "react-router-dom";
import { useFlowPath } from "../../hooks/use-flow-path";
import { routes } from "../config/routes";

type ArgumentTypes<F extends (...args: unknown[]) => unknown> = F extends (...args: infer A) => unknown ? A : never;

export const useRoutes = () => {
  const history = useHistory();
  const flowPath = useFlowPath();

  const goToRoute = (route: string) => () => {
    history.push(flowPath(route));
  };

  return {
    goToCatalog: goToRoute(routes.catalog.raw()),
    goToCheckout: goToRoute(routes.checkout.raw()),
    goToTermsAgreement: goToRoute(routes.termsAgreement.raw()),
    goToThankYouPage: (args: ArgumentTypes<typeof routes.thankYou.apply>) => flowPath(routes.thankYou.apply(...args)),
  };
};
